import { createSelector } from "reselect";

const settingsSelector = state => state.settings;

export const isLoadingSelector = createSelector(
	settingsSelector,
	state => state.isLoading
);
